import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Modal from '../Modal';
import ModalContent from '../Modal/ModalContent';
import ModalFooter from '../Modal/ModalFooter';
import styles from './ConfirmationModal.module.scss';
import { Icon } from '../Icon';
import { CustomButton } from '../Button/Button';

export default function ConfirmationModal(props) {
  const {
    title,
    message,
    open,
    onClose,
    onConfirm,
    confirmationLabel,
    cancelLabel = 'Cancel',
    confirmationVariant = 'danger-outline',
    src,
    loading,
    ...rest
  } = props;
  return (
    <Modal open={open} onClose={onClose} className={cx(styles.confirmationModal)} {...rest}>
      <div className={styles.container} data-cy="confirmation-modal">
        <div className={styles.imgContainer}>
          <Icon className={styles.binIcon} src={src} />
        </div>
        <div className={styles.dataContainer}>
          <ModalContent className={styles.content}>{message}</ModalContent>
          <ModalFooter className={styles.footer}>
            <CustomButton variant="link" label={cancelLabel} onClick={onClose} className={styles.cancelBtn} />
            <CustomButton variant={confirmationVariant} label={confirmationLabel} onClick={onConfirm} loading={loading} />
          </ModalFooter>
        </div>
      </div>
    </Modal>
  );
}

ConfirmationModal.propTypes = {
  confirmationLabel: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.string]).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

ConfirmationModal.defaultProps = {
  loading: false,
};
